




































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
 

class PageParticipationrateRequest extends PageRequest {
  Keyword: string;
  //isrent: number; //nullable
  stime: Date;
  etime: Date;
  atype:number;
  areaid:number;
  qid:number;
  sid:number;
  cid:number;
  vid:number;
}

@Component({
  components: {  },
})
export default class Participationrate extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageParticipationrateRequest = new PageParticipationrateRequest();
  creationTime: Date[] = [];
  editModalShow: boolean = false;

  get list() {
    return this.$store.state.participationrate.list;
  }
  get loading() {
    
    return this.$store.state.participationrate.loading;
  }
  create() {}

  pageChange(page: number) {
   
    this.$store.commit("participationrate/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
     
    this.$store.commit("participationrate/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    if(this.creationTime.length<1){
         this. Stime(1)
      
    }
 
    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      
      this.pagerequest.etime = this.creationTime[1];
    }

    if(this.pagerequest.vid>0){
       this.pagerequest.areaid=this.pagerequest.vid;
       this.pagerequest.atype=4;
    }else if(this.pagerequest.cid>0){
       this.pagerequest.areaid=this.pagerequest.cid;
       this.pagerequest.atype=3;
    }
    else if(this.pagerequest.sid>0){
       this.pagerequest.areaid=this.pagerequest.sid;
       this.pagerequest.atype=2;
    }
   else  if(this.pagerequest.qid>0){
       this.pagerequest.areaid=this.pagerequest.qid;
       this.pagerequest.atype=1;
    }



    await this.$store.dispatch({
      type: "participationrate/getAll",
      data: this.pagerequest,
    });
  }

  get pageSize() {
    return this.$store.state.participationrate.pageSize;
  }
  get totalCount() {
    return this.$store.state.participationrate.totalCount;
  }
  get currentPage() {
    return this.$store.state.participationrate.currentPage;
  }
//vilname: "白粉墙", comname: "自然村", streetname: "衙前镇", cityname: "杭州市", disname: "萧山区", usercount
  columns = [
   
    {
      title: '城市/区',
      render: (h: any, params: any) => {
        
        return h("span", params.row.cityname+'-'+params.row.disname);
      },
    },
    {
      title: '街道',
      key: "streetname",
    },
      {
      title: '社区',
      key: "comname",
    },
    {
      title:'小区',
      key: "vilname",
    },
    {
      title:'总住户',
      key: "usercount",
    },
      {
      title:'参与人数',
      key: "rblistcount",
    },
     {
      title:'参与率',
      
        render: (h: any, params: any) => {
        
        return h("span", params.row.participationrate+'%');
      },
    },
    {
      title:'易腐垃圾重量',
      key: "foodwasteweight",
    },
     {
      title:'其他垃圾重量',
      key: "otherwasteweight",
    },
     {
      title: '垃圾总重量',
      render: (h: any, params: any) => {
       
        return h("span", (params.row.foodwasteweight+params.row.otherwasteweight).toFixed(2));
      },
    },

    {
      title: '时间',
      key: "stime",
     
    }

    
  ];
  async created() {
    this.getpage();
    this.getAreaAll()
  }
  async getAreaAll() {
    await this.$store.dispatch({
      type: "participationrate/getQAreaAllData",
    });
  }
  //获取初始值
    get qarealist(){
         
            return this.$store.state.participationrate.qarea;
     }
      //区下面的街道
       get qarealst(){
           return this.$store.state.participationrate.qarealst;
       }
       set qarealst(val:number){
            this.$store.commit('participationrate/change_qarealst',val);
       }
       //街道的社区
       get sarealst(){
            return this.$store.state.participationrate.sarealst;
       }
       set sarealst(val:number){
          this.$store.commit('participationrate/change_sarealst',val);           
        
       }
       //社区下的小区
      get carealst(){

            return this.$store.state.participationrate.carealst;
       }
       set carealst(val:number){
          this.$store.commit('participationrate/change_carealst',val);           
        
       }
       
     QAreaChange(val:number){
        
        this.pagerequest.qid=val;
       
         
     var dt= this.$store.state.participationrate.qarea;
        dt.forEach(item=>{
        if(item.id==val){
               this.qarealst=item;
            }
          })
            
       }
      SAreaChange(val:number){
       this.pagerequest.sid=val;
       var dt= this.$store.state.participationrate.qarealst.sAreas;
     dt.forEach(item=>{
        if(item.id==val){
         this.sarealst=item;
        }
    })
      }
     CAreaChange(val:number){
         this.pagerequest.cid=val;
       var dt= this.$store.state.participationrate.sarealst.cAreas;
    dt.forEach(item=>{
    if(item.id==val){
         this.carealst=item;
        }
    })
   }
      VAreaChange(val:number){
         this.pagerequest.vid=val;
         
         }
 
     Stime(tp) {


                var nowDate = new Date();

                var nowDayOfWeek = nowDate.getDay(); // 今天本周的第几天
                var nowDay = nowDate.getDate();    // 当前日期
                var nowMonth = nowDate.getMonth(); // 当前月
                var nowYear = nowDate.getFullYear();   // 当前年

                var lastMonthDate = new Date(); //上月日期
                lastMonthDate.setDate(1);
                lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);

                var lastMonth = lastMonthDate.getMonth();


                var nowdaytime =this. formatDate(nowDate);
                var stime = nowdaytime;
                var etime = nowdaytime;

                //今日

                switch (tp) {
                    case 1:
                          nowdaytime = this.formatDate(nowDate);
                          stime = nowdaytime;
                          etime = nowdaytime;
                break;
                    case 2:
                        // 昨天
                        var yesterday = new Date(nowYear, nowMonth, nowDate.setTime(nowDate.getDate() - 1));
                        var yesterdayTime = this.formatDate(yesterday);
                        stime = yesterdayTime;
                        etime = yesterdayTime;

                        break;
                    case 3:
                     
                     
                        // 本周
                        // 本周开始时间
                        var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek+1);
                        var weekStartDateTime =this. formatDate(weekStartDate);
                        var weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
                        var weekEndDateTime = this.formatDate(weekEndDate);


                        stime = weekStartDateTime;
                        etime = weekEndDateTime;
                        break;
                    case 4:
                   
                        // 上周
                        // 上周开始时间
                        var topweekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 6);
                        var topweekStartDateTime =this. formatDate(topweekStartDate);
                        // 上周结束时间
                        var topweekEndDate =new Date(nowYear, nowMonth, nowDay - nowDayOfWeek );
                        var topweekEndDateTime =this. formatDate(topweekEndDate);

                        stime = topweekStartDateTime;
                        etime = topweekEndDateTime;
                        break;
                    case 5:
                    
                        // 本月
                        //获得本月的第一天  
                        var currentMonthFirstDay = new Date(nowYear, nowMonth, 1);
                        var currentMonthFirstDayTime =this. formatDate(currentMonthFirstDay);
                        //获得本月的最后一天  
                        var currentMonthLastDay = new Date(nowYear, nowMonth + 1, 0);
                        var currentMonthLastDayTime =this. formatDate(currentMonthLastDay);
                        stime = currentMonthFirstDayTime;
                        etime = currentMonthLastDayTime;
                        break;
                    case 6:
                       var today = new Date();
                       var preMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                       var preMonthDayCount = preMonth.getDate();

                        // 上月
                        var yesterday =   new Date(nowYear, lastMonth, 1);
                        var yesterdayStartTime =this. formatDate(yesterday);

                        var yesterdayEnd = new Date(nowYear, lastMonth, preMonthDayCount);
                        var yesterdayEndTime =this. formatDate(yesterdayEnd);
                        stime = yesterdayStartTime;
                        etime = yesterdayEndTime;
                        break;
                break;
                    default:
            }
                console.log(stime);
                console.log(etime);
               this. creationTime = [];
               this.creationTime.push( new Date(stime) );
               this.creationTime.push( new Date(etime));
 
            // $("#stime").val(stime);
            //$("#etime").val(etime);

            }

            // 格式化日期：yyyy-MM-dd
              formatDate(date) {
                
                var myyear = date.getFullYear();
                var mymonth = date.getMonth() + 1;
                var myweekday = date.getDate();
                if (mymonth < 10) {
                    mymonth = "0" + mymonth;
                }
                if (myweekday < 10) {
                    myweekday = "0" + myweekday;
                }

                // return (myyear + "-" + mymonth + "-" + myweekday);
                return (myyear + "-" + mymonth + "-" + myweekday);

              //  return date.format('YYYY-MM-DD');
            }

             




//导出
   async  exportExcel() {
    
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "participationrate/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				
					lt.map((item) => { // 这里修改要下载的字段内容
					  
           item.citynamedisname=item.cityname+'-'+item.disname;
           item.allweigh=(item.foodwasteweight+item.otherwasteweight).toFixed(2);
           item.participationrate=item.participationrate+'%';
					  return item;
					});
          
					const filterVal = ['rowNum', 'citynamedisname','streetname' ,'comname', 'vilname', 'usercount', 'rblistcount', 'participationrate','foodwasteweight','otherwasteweight','allweigh','stime'];// 取出要下载的表头字段
					const tHeader = ['序号','城市/区','街道','社区','小区','总住户','参与人数','参与率','易腐垃圾重量','其他垃圾重量','总重量','时间段'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '垃圾分类参与统计');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

   
			


 

}
